import React from 'react';

export default function NumberCell({ value, column }) {
  if (value === '' || value === null || value === undefined) return <span />;

  let display = value;
  if (typeof value === 'number') {
    if (column.is_currency) {
      // Currency: show with $ prefix and thousands separator (same as old index)
      display = '$' + value.toLocaleString('es-CO');
    } else {
      // Non-currency: show raw value without formatting
      display = value;
    }

    // Option: use decimal_count_show from configuration
    // const decimals = column.decimal_count || 0;
    // display = value.toFixed(decimals);
    // if (column.is_currency) {
    //   display = '$' + Number(display).toLocaleString('es-CO', {
    //     minimumFractionDigits: decimals,
    //     maximumFractionDigits: decimals
    //   });
    // }
  }

  return <span>{display}</span>;
}
